// extracted by mini-css-extract-plugin
module.exports = {"loader":"main_loader__2-Ruw","loader-content":"main_loader-content__3RzWS"};